const ActionTypes = {
  // General
  SHOW_ALERT: "SHOW_ALERT",
  HIDE_ALERT: "HIDE_ALERT",
  
  SHOW_LOADING: "SHOW_LOADING",
  HIDE_LOADING: "HIDE_LOADING",
  
  SESSION_EXPIRED: "SESSION_EXPIRED",

  // User
  GET_USER: "GET_USER",
  IsLogin: "IsLogin",
  IsLogout: "IsLogout",
 
  //Dashboard
  GET_DASHBOARD_DATA: "GET_DASHBOARD_DATA",
  CLEAR_DASHBOARD_DATA: "CLEAR_DASHBOARD_DATA",

  GET_USER_DETAILS: "GET_USER_DETAILS",
  CLEAR_USER_DETAILS: "CLEAR_USER_DETAILS",
  DEACTIVATE_USER_YARDSALE: "DEACTIVATE_USER_YARDSALE",

  // Yardsales
  GET_YARDSALES: "GET_YARDSALES",
  CLEAR_YARDSALES: "CLEAR_YARDSALES",

  GET_YARDSALE_DETAILS: "GET_YARDSALE_DETAILS",
  CLEAR_YARDSALE_DETAILS: "CLEAR_YARDSALE_DETAILS",

  DEACTIVATE_YARDSALE: "DEACTIVATE_YARDSALE",

  //Pages
  GET_SUPPORT_QUERIES: "GET_SUPPORT_QUERIES",
  DEL_SUPPORT_QUERY: "DEL_SUPPORT_QUERY",

  GET_WEB_QUERIES: "GET_WEB_QUERIES",

  GET_DISCOUNT_CODES: "GET_DISCOUNT_CODES",
  DEL_DISCOUNT_CODE: "DEL_DISCOUNT_CODE",
  ADD_DISCOUNT_CODE: "ADD_DISCOUNT_CODE",

  //Payments
  GET_PAYMENTS: "GET_PAYMENTS",
  CLEAR_PAYMENTS: "CLEAR_PAYMENTS",

};

export default ActionTypes;
